import { Component, inject } from '@angular/core';

import { SurveyConditionalsService } from '../../../../services/survey-conditionals.service';
import { QuestionType } from '@empathy/survey/base';

@Component({
  selector: 'empathy-conditional-single-choice-form',
  templateUrl: './conditional-single-choice-form.component.html',
  styleUrls: ['./conditional-single-choice-form.component.scss']
})
export class ConditionalSingleChoiceFormComponent {
  questionType = QuestionType;
  surveyConditionalsService = inject(SurveyConditionalsService);
}
